export const topics = [
  {
    slug: "campus",
    name: "校园热点",
    icon: "ri-fire-line",
    description: "校园墙热议、突发通知、评优评先的第一现场。",
    postCount: 1842,
  },
  {
    slug: "dorm",
    name: "宿舍日常",
    icon: "ri-home-smile-line",
    description: "舍友相处、水电维修、深夜噪音，宿舍那点事都在这里。",
    postCount: 1367,
  },
  {
    slug: "love",
    name: "情感八卦",
    icon: "ri-heart-3-line",
    description: "表白墙、恋爱日常、分分合合，校园情感观察站。",
    postCount: 2104,
  },
  {
    slug: "study",
    name: "学习考证",
    icon: "ri-book-2-line",
    description: "选课攻略、绩点自救、四六级与各类证书经验贴。",
    postCount: 988,
  },
  {
    slug: "club",
    name: "社团活动",
    icon: "ri-group-line",
    description: "招新、演出、比赛和社团八卦，课余生活全记录。",
    postCount: 745,
  },
  {
    slug: "career",
    name: "求职实习",
    icon: "ri-briefcase-4-line",
    description: "校招时间线、简历踩坑、实习避雷的真实分享。",
    postCount: 623,
  },
  {
    slug: "food",
    name: "食堂测评",
    icon: "ri-restaurant-2-line",
    description: "各校食堂新窗口试吃与排队实录，吃货必看。",
    postCount: 531,
  },
  {
    slug: "grad",
    name: "考研保研",
    icon: "ri-graduation-cap-line",
    description: "保研名单、备考作息、复试经验，升学路上的同伴。",
    postCount: 806,
  },
];